import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
import ServicesGrid from "../components/ServicesGrid";
import Process from "../components/Process";
import Education from "../components/Education";
import Faq from "../components/Faq";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";
import useSeo from "../hooks/useSeo";
import { SITE_URL } from "../lib/site";

export default function Landing() {
  useSeo({
    title:
      "ZOZO Venture — Startup Funding, Company Registration & One-Stop Startup Solutions In India",
    description:
      "Startup funding services, fundraising consultant, pitch deck and DPIIT recognition for Indian founders — pre-seed, seed, angel, venture capital, venture debt and government grants. Plus Company Name Availability check, Private Limited / OPC / LLP / Partnership / Proprietorship Registration, GST, banking, payment gateways, virtual office and digital presence. By ZOZO Venture.",
    canonical: `${SITE_URL}/`,
    image:
      "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1200",
    type: "website",
  });

  return (
    <div className="min-h-screen bg-white text-[#0A0A0A] font-body" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <ServicesGrid />
        <Process />
        <Education />
        <Faq />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
